module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/47388a326a01718897c15862b0f182a4.png";